import React from "react";
import LayoutDashboard from "layouts/layout-dashboard-collapse";
import "../components/WorkshopTopbar.css";

const WorkshopTutorialPage = () => {
  return (
    <LayoutDashboard>
      <div className="container-xl py-4 workshop-page-scope workshop-content-panel">
        <div className="page-header d-print-none mb-4">
          <div className="row align-items-center">
            <div className="col">
              <h2 className="page-title">Panduan Modul Workshop (Berdasarkan Sistem)</h2>
              <div className="text-muted mt-1">
                Petunjuk akurat sesuai antarmuka (UI), tombol, dan menu yang aktif di sistem saat ini.
              </div>
            </div>
          </div>
        </div>

        <div className="card mb-4">
          <div className="card-body">
            <h3 className="mb-4 text-primary border-bottom pb-2">1. Dashboard Mekanik (Menu: Workshop &gt; Mekanik)</h3>
            <p>Halaman ini bernama "Mekanik ATV" dan berfungsi sebagai pusat kontrol kendaraan operasional dan pelaporan servis.</p>
            
            <div className="ms-3 mb-4">
              <h5 className="text-dark">A. Tombol Aksi di Header:</h5>
              <ul>
                <li><strong>Manage Status (Tombol Kuning + Ikon Setting):</strong> Membuka popup manajemen status kendaraan.</li>
                <li><strong>Kelola Template (Tombol Kuning + Ikon Setting):</strong> Mengelola template jenis perbaikan servis.</li>
                <li><strong>Manage ATV (Tombol Hijau + Ikon Truk):</strong> Menambah dan mengatur data master kendaraan ATV.</li>
                <li><strong>Service Reports (Tombol Biru Muda):</strong> Berpindah ke halaman riwayat pelaporan servis.</li>
                <li><strong>Stock Transfers (Tombol Biru Tua):</strong> Berpindah ke halaman pemindahan stok inventaris antar gudang.</li>
              </ul>
              
              <h5 className="text-dark mt-3">B. Pencarian & Filter:</h5>
              <ul>
                <li>Terdapat kolom pencarian berikon kaca pembesar untuk mencari kendaraan berdasarkan <strong>Plat Nomor</strong>.</li>
                <li>Terdapat barisan "Summary Stats" di atas layar yang dapat diklik untuk mem-filter kendaraan berdasarkan statusnya (misal: "Filter aktif: Broken"). Klik "Hapus filter" untuk mereset.</li>
              </ul>

              <h5 className="text-dark mt-3">C. Kartu Kendaraan (Vehicle Card):</h5>
              <p>Kendaraan ditampilkan dalam bentuk grid kartu. Klik kendaraan tersebut untuk melihat <strong>Vehicle Detail</strong> secara spesifik.</p>
            </div>
          </div>
        </div>

        <div className="card mb-4">
          <div className="card-body">
            <h3 className="mb-4 text-primary border-bottom pb-2">2. Manajemen Inventaris (Menu: Workshop &gt; Inventory)</h3>
            <p>Halaman "Workshop Inventory Management" digunakan untuk mengelola stok barang, sparepart, dan alat-alat mekanik.</p>
            
            <div className="ms-3 mb-4">
              <h5 className="text-dark">A. Tombol Aksi di Header:</h5>
              <ul>
                <li><strong>Warehouse Management (Tombol Abu-abu):</strong> Mengelola master data gudang penyimpanan (misal: Gudang Mekanik, Gudang Office).</li>
                <li><strong>Manage Categories (Tombol Biru Muda):</strong> Mengelola pengkategorian barang.</li>
                <li><strong>Tambah Item (Tombol Hijau + Ikon Plus):</strong> Menambahkan daftar barang baru ke sistem.</li>
                <li><strong>Bulk Transfer (Tombol Kuning):</strong> Melakukan perpindahan stok massal.</li>
              </ul>

              <h5 className="text-dark mt-3">B. Tabel Inventaris & Aksi Lanjutan:</h5>
              <p>Pada baris setiap barang di tabel, terdapat serangkaian aksi yang dapat dilakukan melalui ikon titik tiga (Action Menu) atau ikon di tabel:</p>
              <ul>
                <li><strong>Edit / Delete:</strong> Mengubah atau menghapus data item.</li>
                <li><strong>Update Stock (Stock Update Modal):</strong> Melakukan penyesuaian/perubahan kuantitas stok.</li>
                <li><strong>Transfer Stock:</strong> Memindahkan stok spesifik barang ini ke gudang lain.</li>
                <li><strong>Item History:</strong> Melihat jejak riwayat masuk/keluar barang tersebut.</li>
                <li><strong>Upload Image:</strong> Menambahkan atau mengganti foto barang tersebut.</li>
                <li><strong>Manual Stock Update:</strong> Menyesuaikan saldo stok secara manual jika diperlukan koreksi administratif.</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="card mb-4">
          <div className="card-body">
            <h3 className="mb-4 text-primary border-bottom pb-2">3. Rute Pembelian (Supplier, PO, Receipts)</h3>
            <p>Ini adalah rute administratif untuk pemesanan stok dari pihak luar.</p>
            
            <div className="ms-3 mb-4">
              <ul>
                <li><strong>Supplier (Workshop &gt; Supplier):</strong> Halaman manajemen data toko atau pemasok sparepart. Data ini digunakan saat menerbitkan PO.</li>
                <li><strong>Purchase Orders (Workshop &gt; Purchase Orders):</strong> Halaman untuk membuat dokumen pesanan pembelian ke Supplier.</li>
                <li><strong>Purchase Receipts (Workshop &gt; Purchase Receipts):</strong> Halaman penerimaan. Saat barang fisik tiba, penerimaan akan dicatat di sini dengan merujuk ke PO awal. Jika berhasil disimpan, secara logis jumlah ini akan memperbarui angka di menu <em>Inventory</em>.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </LayoutDashboard>
  );
};

export default WorkshopTutorialPage;
